<app-loading *ngIf="contentReady"></app-loading>

<div class="bbm-page finance-mobile-page">
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero noPrint">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar bbm-avatar-contain">
            <img
              src="/assets/income.png"
              [alt]="'income' | transloco"
            >
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ "Finance" | transloco }}
            </span>

            <h2>
              {{ "Affiliation Payments Manager" | transloco }}
            </h2>

            <p>
              {{ stockTotal || 0 }}
              {{ "payments" | transloco }}
            </p>
          </div>

        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ stockTotal || 0 }}
          </strong>

          <span>
            {{ "payments" | transloco }}
          </span>
        </div>

      </div>

      <!-- HERO ACTIONS -->
      <div class="bbm-actions-grid bbm-hero-actions">

        <button
          type="button"
          class="bbm-action-btn"
          (click)="exportToExcel()"
        >
          <i class="fa-solid fa-file-excel"></i>

          <span>
            {{ "export to excel" | transloco }}
          </span>
        </button>

        <button
          *ngIf="isAdmin || isSubAdmin"
          type="button"
          class="bbm-action-btn bbm-action-primary"
          (click)="openUsersFilter()"
        >
          <i class="fa-solid fa-filter"></i>

          <span>
            {{ "Order By" | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- SUMMARY -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <!-- TOTAL ORDERS -->
      <div class="bbm-detail-chip bbm-detail-primary">
        <i class="fa-solid fa-cart-shopping"></i>

        <span>
          {{ 'إجمالي الطلبات' | transloco }}
        </span>

        <strong>
          {{ totalAllOrders || 0 }}
        </strong>
      </div>

      <!-- TOTAL COMMISSION -->
      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-money-bill-wave"></i>

        <span>
          {{ 'إجمالي العمولة' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ totalAllDue | number:'1.2-2' }}
          {{ 'EGP' | transloco }}
        </strong>
      </div>

      <!-- COMPLETED -->
      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-circle-check"></i>

        <span>
          {{ 'المكتمل' | transloco }}
        </span>

        <strong>
          {{ totalCompleted || 0 }}
        </strong>
      </div>

      <!-- PENDING -->
      <div class="bbm-detail-chip bbm-detail-warning">
        <i class="fa-solid fa-clock"></i>

        <span>
          {{ 'المعلق' | transloco }}
        </span>

        <strong>
          {{ totalPending || 0 }}
        </strong>
      </div>

    </section>

    <!-- PAYMENT RECORDS -->
    <section class="bbm-records-section">

      <div class="bbm-list-head noPrint">

        <div>
          <span>
            {{ "Payments" | transloco }}
          </span>

          <h3>
            {{ "Affiliation Payments Manager" | transloco }}
          </h3>
        </div>

        <button
          *ngIf="selectedUserId && (isAdmin || isSubAdmin)"
          type="button"
          class="bbm-action-btn bbm-action-warning bbm-action-compact"
          (click)="clearUserFilter()"
        >
          <i class="fa-solid fa-rotate-left"></i>

          <span>
            {{ "All" | transloco }}
          </span>
        </button>

      </div>

      <!-- EMPTY STATE -->
      <div
        class="bbm-empty-state"
        *ngIf="noData"
      >
        <app-nodata></app-nodata>
      </div>

      <!-- PAYMENT LIST -->
      <div
        class="bbm-ticket-list"
        *ngIf="!noData"
      >

        <article
          class="bbm-ticket"
          [class.bbm-ticket-success]="isCompleted(element)"
          [class.bbm-ticket-warning]="!isCompleted(element)"
          *ngFor="let element of allData; index as i"
        >

          <!-- CARD TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-solid fa-user-secret"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ "Order By" | transloco }}
                </span>

                <h3>
                  {{ element.user_last_name || '-' }}
                </h3>
              </div>

            </div>

            <span
              class="bbm-status-pill"
              [class.bbm-status-success]="isCompleted(element)"
              [class.bbm-status-warning]="!isCompleted(element)"
            >
              <i
                class="fa-solid"
                [class.fa-check]="isCompleted(element)"
                [class.fa-clock]="!isCompleted(element)"
              ></i>

              {{
                isCompleted(element)
                  ? ('مكتمل' | transloco)
                  : ('معلق' | transloco)
              }}
            </span>

          </div>

          <!-- PAYMENT DETAILS -->
          <div class="bbm-details-grid">

            <!-- DUE -->
            <div
              class="bbm-detail-chip bbm-detail-wide"
              [class.bbm-detail-success]="isCompleted(element)"
              [class.bbm-detail-warning]="!isCompleted(element)"
            >
              <i class="fa-solid fa-money-bill-wave"></i>

              <span>
                {{ "due" | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ element.due | number:'1.2-2' }}
                {{ "egp" | transloco }}
              </strong>
            </div>

            <!-- INVOICE -->
            <div class="bbm-detail-chip">
              <i class="fa-solid fa-file-invoice"></i>

              <span>
                {{ "invoice" | transloco }}
              </span>

              <strong
                class="bbm-code-value"
                dir="ltr"
              >
                #{{ element.order_id }}
              </strong>
            </div>

            <!-- REQUESTED -->
            <div class="bbm-detail-chip">
              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                {{ "requested by user" | transloco }}
              </span>

              <span
                class="bbm-state-icon"
                [class.bbm-state-icon-success]="isRequested(element)"
                [class.bbm-state-icon-danger]="!isRequested(element)"
              >
                <i
                  class="fa-solid"
                  [class.fa-check]="isRequested(element)"
                  [class.fa-xmark]="!isRequested(element)"
                ></i>
              </span>
            </div>

            <!-- COMPLETED -->
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-money-check-dollar"></i>

              <span>
                {{ "complatedpayment" | transloco }}
              </span>

              <span
                class="bbm-state-icon"
                [class.bbm-state-icon-success]="isCompleted(element)"
                [class.bbm-state-icon-danger]="!isCompleted(element)"
              >
                <i
                  class="fa-solid"
                  [class.fa-check]="isCompleted(element)"
                  [class.fa-xmark]="!isCompleted(element)"
                ></i>
              </span>
            </div>

          </div>

          <!-- PAYMENT ACTION -->
          <div
            class="bbm-actions-grid noPrint"
            *ngIf="
              (isAdmin || isSubAdmin) &&
              !isCompleted(element)
            "
          >
            <button
              type="button"
              class="bbm-action-btn bbm-action-success bbm-action-wide"
              (click)="
                paymentCompleted(
                  element.id,
                  element.due,
                  element.user_last_name
                )
              "
            >
              <i class="fa-solid fa-circle-check"></i>

              <span>
                {{ "payment done" | transloco }}
              </span>
            </button>
          </div>

        </article>

      </div>

      <!-- PAGINATION -->
      <mat-paginator
        *ngIf="!noData"
        class="bbm-paginator noPrint"
        [length]="stockTotal"
        [pageSize]="perPage"
        [hidePageSize]="true"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>

    </section>

    <!-- HIDDEN EXPORT TABLE -->
    <table
      id="afiliationpaymenttable"
      class="bbm-export-table"
    >
      <thead>
        <tr>
          <th>
            {{ "Order By" | transloco }}
          </th>

          <th>
            {{ "invoice" | transloco }}
          </th>

          <th>
            {{ "due" | transloco }}
          </th>

          <th>
            {{ "requested by user" | transloco }}
          </th>

          <th>
            {{ "complatedpayment" | transloco }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let element of allData">
          <td>
            {{ element.user_last_name }}
          </td>

          <td>
            #{{ element.order_id }}
          </td>

          <td>
            {{ element.due }}
          </td>

          <td>
            {{ isRequested(element) ? 'Yes' : 'No' }}
          </td>

          <td>
            {{ isCompleted(element) ? 'Yes' : 'No' }}
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</div>

<!-- USERS FILTER MODAL -->
<div
  *ngIf="showAllUsers"
  class="bbm-modal-backdrop noPrint"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "Filter" | transloco }}
        </span>

        <h3>
          {{ "Order By" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-choice-list bbm-modal-choice-list">

      <!-- ALL USERS -->
      <button
        type="button"
        class="bbm-choice-btn"
        [class.is-selected]="!selectedUserId"
        (click)="clearUserFilter()"
      >
        <span class="bbm-choice-icon">
          <i class="fa-solid fa-users"></i>
        </span>

        <span class="bbm-choice-copy">
          <strong>
            {{ "All" | transloco }}
          </strong>

          <span>
            {{ 'عرض كل المدفوعات' | transloco }}
          </span>
        </span>
      </button>

      <!-- USER OPTIONS -->
      <button
        type="button"
        class="bbm-choice-btn"
        [class.is-selected]="selectedUserId == el.id"
        *ngFor="let el of allUsers"
        (click)="selectUser(el.id)"
      >
        <span class="bbm-choice-icon">
          <i class="fa-solid fa-user"></i>
        </span>

        <span class="bbm-choice-copy">
          <strong>
            {{ el.last_name || '-' }}
          </strong>

          <span>
            {{ "Order By" | transloco }}
          </span>
        </span>
      </button>

    </div>

  </section>
</div>